export default function QualityCard({ preview }) {
    if (!preview || preview.qualityScore == null) return null;

    const score = preview.qualityScore;
    const status = preview.qualityStatus || (score >= 85
        ? "Excellent"
        : score >= 70
            ? "Good"
            : "Needs Improvement");

    const badgeClass =
        score >= 85
            ? "excellent"
            : score >= 70
                ? "good"
                : "weak";

    return (
        <div className="wg-quality-card">
            <div className="wg-quality-header">
                <div>
                    <h3>Website Quality</h3>
                    <p className="wg-quality-subtitle">
                        AI evaluator result for this generated preview
                    </p>
                </div>

                <div className={`wg-quality-badge ${badgeClass}`}>
                    {score}/100
                </div>
            </div>

            <div className="wg-quality-status-row">
                <strong>Status:</strong>
                <span>{status}</span>
            </div>

            {preview.qualitySummary ? (
                <p className="wg-quality-summary">{preview.qualitySummary}</p>
            ) : null}

            {Array.isArray(preview.qualityIssues) && preview.qualityIssues.length > 0 ? (
                <div className="wg-quality-section">
                    <strong>Issues</strong>
                    <ul>
                        {preview.qualityIssues.slice(0, 5).map((item, idx) => (
                            <li key={idx}>{item}</li>
                        ))}
                    </ul>
                </div>
            ) : null}

            {Array.isArray(preview.qualitySuggestions) && preview.qualitySuggestions.length > 0 ? (
                <div className="wg-quality-section">
                    <strong>Suggestions</strong>
                    <ul>
                        {preview.qualitySuggestions.slice(0, 5).map((item, idx) => (
                            <li key={idx}>{item}</li>
                        ))}
                    </ul>
                </div>
            ) : null}

            {!preview.isPublishReady ? (
                <div className="wg-quality-warning">
                    This website should be improved before publishing.
                </div>
            ) : (
                <div className="wg-quality-ok">
                    This website is ready for publish review.
                </div>
            )}
        </div>
    );
}